import React from "react"
import { uniq, truncate, filter } from "lodash"
import { Tooltip } from "antd"
import { LOCAL_USER_ID } from "../../utils/storage"
import { buttonAction_s } from "../Snowplow/config2"
import DOMPurify from "dompurify"

export const columns = (setStateFrom, employeesSelected) => {
  let lastItems = []
  const grandparents = {}
  let data_button_destinatario = {
    category: window.location.hash
      ? window.location.hash
      : window.location.pathname,
    action: "Editar destinatarios",
    label: "Click a Editar destinatarios",
    property: "link",
    value: LOCAL_USER_ID(),
  }
  const buttonAction_ed_destinatarios = () => {
    buttonAction_s(data_button_destinatario)
  }
  return [
    {
      title: "División",
      dataIndex: "name",
      index: "name",
      render: (text, record) => {
        const lineHtml =
          "<div class='measurement-select-recipient-table-line'></div>" /* USADO */
        const lineTHtml =
          "<div class='measurement-select-recipient-table-line-t'></div>" /* USADO */
        const lineLHtml =
          "<div class='measurement-select-recipient-table-line-l'></div>" /* USADO */
        const lineLastHtml =
          "<div class='measurement-select-recipient-table-linelast'></div>" /* USADO */
        let divs = ""

        if (record.children.length) {
          lastItems = uniq([
            ...lastItems,
            record.children[record.children.length - 1].id_division,
          ])
        }

        if (record.level === 1) {
          grandparents[record.id_division] = ""
        }

        if (lastItems.includes(record.id_division) && record.level > 1) {
          divs =
            (grandparents[record.id_parent] || "").replace(/e-t/g, "e") +
            lineLHtml
          grandparents[record.id_division] = divs
          // if (grandparents[record.id_parent]) {
          // }
        }

        if (record.level > 1 && !lastItems.includes(record.id_division)) {
          divs =
            (grandparents[record.id_parent] || "").replace(/e-t/g, "e") +
            lineTHtml
          grandparents[record.id_division] = divs
          // if (grandparents[record.id_parent]) {
          // }
        }

        if (
          lastItems.includes(record.id_parent) &&
          !lastItems.includes(record.id_division)
        ) {
          divs =
            (grandparents[record.id_parent] || "").replace(
              /line-l/g,
              "linelast"
            ) + lineTHtml
          grandparents[record.id_division] = divs
          // if (grandparents[record.id_parent]) {
          // }
        }

        if (
          lastItems.includes(record.id_parent) &&
          lastItems.includes(record.id_division)
        ) {
          divs =
            (grandparents[record.id_parent] || "").replace(
              /line-l/g,
              "linelast"
            ) + lineLHtml
          grandparents[record.id_division] = divs
          // if (grandparents[record.id_parent]) {
          // }
        }

        const sanitizedHTML = DOMPurify.sanitize(divs);
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {record.level !== 1 && (
              <div
                style={{ display: "flex" }}
                dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
              />
            )}
            <Tooltip title={text}>{truncate(text, { length: 40 })}</Tooltip>
          </div>
        )
      },
    },
    {
      title: "División superior",
      dataIndex: "name_parent",
      key: "name_parent",
      render: (text, record) => {
        if (record.level === 1) {
          return <strong style={{ textTransform: "uppercase" }}>{text}</strong>
        }

        return <Tooltip title={text}>{truncate(text, { length: 40 })}</Tooltip>
      },
    },
    {
      title: "Destinatarios",
      dataIndex: "employees",
      key: "employees",
      render: (employees) => {
        const countEmployeesSelected = filter(employees, (item) => {
          if (employeesSelected) {
            return employeesSelected.includes(item.id_employee)
          }
          return false
        })
        const res = `${countEmployeesSelected.length}/${employees.length}`
        let color = ""

        if (res === "0/0") {
          color = "#EA6364"
        }

        return (
          <span
            style={{
              color,
            }}>{`${countEmployeesSelected.length}/${employees.length}`}</span>
        )
      },
    },
    {
      title: "Nivel",
      dataIndex: "level",
      key: "level",
    },
    {
      title: "Acciones",
      dataIndex: "actions",
      render: (_, record) => {
        const countEmployeesSelected = filter(record.employees, (item) => {
          if (employeesSelected) {
            return employeesSelected.includes(item.id_employee)
          }
          return false
        })

        const res = `${countEmployeesSelected.length}/${record.employees.length}`

        if (res === "0/0") return "-"
        return (
          <span
            onClick={() => {
              setStateFrom("modalOpenReceiver", true)
              setStateFrom("divisionSelected", record)
              setStateFrom("divisionEmployeesSelected", record.employees)
              buttonAction_ed_destinatarios()
            }}
            className="measurement-select-recipient-table-recipient">
            Editar destinatarios
          </span>
        )
      },
    },
  ]
}
